import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "roaming-search" }
const _hoisted_2 = { class: "roaming-search__fields" }
const _hoisted_3 = { class: "roaming-search__fields-wrapper" }
const _hoisted_4 = ["placeholder"]

import type { RoamingCountryStruct } from "@/struct/RoaminStruct";
import {
  ref,
  computed,
  watch,
  useTemplateRef,
  onMounted,
} from "vue";
import { GetCountries } from "@/server/api/roaming/get-countries.get";
import RoamingCountersListWindow from "@/components/roaming/RoamingCountersListWindow.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'RoamingSearch',
  props: {
    "modelValue": {
  default: null,
},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

//import RoamingService from "~/services/RoamingService";
const selectedCountry = _useModel<RoamingCountryStruct | null>(__props, "modelValue");
const roamingSearchInputElement = useTemplateRef<HTMLDivElement>(
  "roaming-search-input"
);

const search = ref("");
const isShowSelection = ref(false);
const countersList = ref<RoamingCountryStruct[] | null>(null);
const { t } = useI18n();

const getCounters = (search = "" as string) => {
  GetCountries(search)
    .then((countries) => {
      countersList.value = countries;
    })
    .catch((err) => {
      console.log("error get counters", err);
    });
};
const openSelection = () => {
  isShowSelection.value = true;
};
const closeSelection = () => {
  isShowSelection.value = false;
};
const setFocus = () => {
  if (!roamingSearchInputElement.value) return;
  roamingSearchInputElement.value.focus();
};
const selectCountry = (country: RoamingCountryStruct) => {
  selectedCountry.value = country;
};
const onInput = (event: InputEvent & { target: HTMLInputElement }) => {
  search.value = event.target.value.replace(/[^А-Яа-яЁё]/g, "");
  getCounters(search.value);
};
const isMatchSelectedSearch = computed(
  () => selectedCountry.value?.country_name_ru === search.value
);

watch(
  () => selectedCountry.value,
  (newSelectedCountry) => {
    if (!newSelectedCountry) return;
    search.value = newSelectedCountry.country_name_ru;
    isShowSelection.value = false;
    getCounters(search.value);
  }
);
watch(
  () => isMatchSelectedSearch.value,
  (newIsMatchSelectedSearch) => {
    if (!newIsMatchSelectedSearch) {
      selectedCountry.value = null;
    }
  }
);
onMounted(() => {
  getCounters();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "roaming-search__fields-input caption-medium",
          ref: "roaming-search-input",
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          onFocus: openSelection,
          onInput: onInput,
          placeholder: _unref(t)('roaming.search.placeholder'),
          maxlength: "60"
        }, null, 40, _hoisted_4), [
          [_vModelText, search.value]
        ]),
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (!isShowSelection.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: setFocus,
                  class: "roaming-search__fields-icon color-grey-blue"
                }, [
                  _createVNode(BaseIcon, { name: "search" })
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onClick: closeSelection,
                  class: "roaming-search__fields-icon --close color-grey-blue"
                }, [
                  _createVNode(BaseIcon, { name: "close" })
                ]))
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_Transition, {
      name: "drop",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (countersList.value && isShowSelection.value)
          ? (_openBlock(), _createBlock(RoamingCountersListWindow, {
              key: 0,
              class: "roaming-search__selection",
              countersList: countersList.value,
              uuidActive: selectedCountry.value?.uuid,
              isSelectType: true,
              onSelect: selectCountry
            }, null, 8, ["countersList", "uuidActive"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})